var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00049 10.0005L10.0005 1.00049C10.7961 1.00049 11.5592 1.31656 12.1218 1.87917C12.6844 2.44178 13.0005 3.20484 13.0005 4.00049V8.00049H18.6605C18.9504 7.99721 19.2376 8.05699 19.5021 8.17571C19.7666 8.29442 20.0021 8.46922 20.1923 8.688C20.3826 8.90678 20.523 9.16431 20.6038 9.44274C20.6847 9.72117 20.704 10.0138 20.6605 10.3005L19.2805 19.3005C19.2082 19.7774 18.9659 20.2121 18.5984 20.5245C18.2309 20.8369 17.7628 21.0059 17.2805 21.0005H6.00049M6.00049 10.0005V21.0005M6.00049 10.0005H3.00049C2.47006 10.0005 1.96135 10.2112 1.58627 10.5863C1.2112 10.9613 1.00049 11.4701 1.00049 12.0005V19.0005C1.00049 19.5309 1.2112 20.0396 1.58627 20.4147C1.96135 20.7898 2.47006 21.0005 3.00049 21.0005H6.00049",
    stroke: "#00A3FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpSelected);
export default __webpack_public_path__ + "static/media/thumbsUpSelected.4696cf711b9fd7c89043dfb0fdceb572.svg";
export { ForwardRef as ReactComponent };